import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

const initialState: any = {
  loading: false,
  inquiryData: null,
  message: "",
  success: false,
};

const inquirySlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {
    getInquiryDataRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.message = "";
    },
    getInquiryDataSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.inquiryData = action.payload;
      state.success = true;
    },
    getInquiryDataFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.message = action.payload;
      state.success = false;
    },
    clearInquiryData(state) {
      state.loading = false;
      state.inquiryData = null;
      state.message = "";
      state.success = false;
    },
    updateInquiryStatusRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.message = "";
    },
    updateInquiryStatusSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.success = true;
    },
    updateInquiryStatusFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.message = action.payload;
    },
  },
});

//Actions
export const inquiryActions = inquirySlice.actions;

//Selectors
export const selectInquiryData = (state: RootState) => state.inquiry.inquiryData;
export const selectInquiryLoading = (state: RootState) => state.inquiry.loading;
export const selectInquiryError = (state: RootState) => state.inquiry.message;

//Reducers
const inquiryReducer = inquirySlice.reducer;
export default inquiryReducer;
